import { IHistoryItem } from 'app/models/history.models';
import { INoteDto } from 'app/models/note.models';

export const getFullHistory = (eventHistory: IHistoryItem[] = [], notes: INoteDto[] = []): (IHistoryItem | INoteDto)[] => {
  // @ts-ignore
  return eventHistory.concat(notes).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
};
